/** Category mapping shared by server and price preview. */
export function mapCategories(
  sourceCategories: string | any[] | undefined,
  categoryMappings: any[],
  defaultCategory?: { id: number; name: string }
): { id?: number; name: string }[] {
  if (!sourceCategories) return [];

  // Helper: find mapping for a category string
  const findMapping = (cat: string) => {
    return categoryMappings?.find((m: any) => {
      const srcVal = m.sourceValue || m.sourceFieldValue;
      if (!srcVal) return false;
      // Exact match
      if (srcVal === cat) return true;
      // Case-insensitive match
      if (srcVal.toLowerCase() === cat.toLowerCase()) return true;
      // Match without parentheses (both sides)
      const catNorm = cat.replace(/[()]/g, '').trim();
      const srcNorm = srcVal.replace(/[()]/g, '').trim();
      if (srcNorm === catNorm || srcNorm.toLowerCase() === catNorm.toLowerCase()) return true;
      return false;
    });
  };

  // First try exact match on the whole string (most common case)
  if (typeof sourceCategories === 'string') {
    const exactMapping = findMapping(sourceCategories.trim());
    if (exactMapping?.targetId) {
      return [{ id: exactMapping.targetId, name: exactMapping.targetName || sourceCategories }];
    }
  }

  // If no exact match, split and try each part
  let categories: string[] = [];
  if (typeof sourceCategories === 'string' && sourceCategories) {
    categories = sourceCategories
      .split(/[|>]/)
      .map(s => s.trim())
      .filter(Boolean);
  } else if (Array.isArray(sourceCategories)) {
    categories = sourceCategories
      .map(c => typeof c === 'string' ? c : c?.name)
      .filter(Boolean);
  }

  const result: { id?: number; name: string }[] = [];
  for (const cat of categories) {
    const mapping = findMapping(cat);
    if (mapping?.targetId) {
      result.push({ id: mapping.targetId, name: mapping.targetName || cat });
    }
  }

  // Fallback: koristi konfigurabilnu default kategoriju ili hardkodiranu ako nije postavljena
  if (result.length === 0 && sourceCategories) {
    if (defaultCategory?.id) {
      result.push({ id: defaultCategory.id, name: defaultCategory.name });
    } else {
      // Legacy fallback
      result.push({ id: 73, name: 'Nema Kategoriju' });
    }
  }

  return result;
}
